import { VStack, Box, Text, Link } from '@chakra-ui/react'
import { buildSearchUrl } from '@!/Util'

export const Title = ({ title }) => {
  return (
    <VStack spacing={1} alignItems="left" w="100%">
      <Box borderRadius="3px" bgColor="primary.main" width={'fit-content'}>
        <Text fontSize="3xs" color="label.white" fontWeight="bold" px={2.5}>
          {title.free_volume_count}巻無料
        </Text>
      </Box>
      <Text>{title.title_name}</Text>
      <Box>
        {title.author_names && (
          <Text fontSize="3xs">
            著者：
            {title.author_names
              .map((author, index) => (
                <Link key={index} textDecoration="none" href={buildSearchUrl('author', author)}>
                  {author}
                </Link>
              ))
              .reduce((prev, curr) => [prev, ', ', curr])}
          </Text>
        )}
        {title.publisher_name && (
          <Text fontSize="3xs">
            出版社：
            <Link textDecoration="none" href={buildSearchUrl('publisher', title.publisher_name)}>
              {title.publisher_name}
            </Link>
          </Text>
        )}
      </Box>
    </VStack>
  )
}
